<template>
  <section class="step1-form step2_bl"
           :style="{minHeight:(screenHeight-85)+'px'}">
    <div v-if="this.$route.query.yanse == 1"
         class="step-form__step-num2">5/5</div>
    <div v-if="this.$route.query.yanse == 2"
         class="step-form__step-num">5/5</div>
    <!--<div v-if="Number(userInfo.crmCustomerType) === 1">-->
    <div>
      <div class="step-form__main">
        <h1 class="step-form__title">{{this.$route.query.productName}}-申请信息确认</h1>
        <el-row :gutter="0">
          <el-col :span="16">
            <el-form class="step-form__form"
               :label-width="'50%'"
               :model="step5Form"
               :rules="rules"
               ref="step5Form">
               <el-form-item label="融资申请编号">
                 {{this.applyCode}}
               </el-form-item>  
              <el-form-item label="可申请融资金额">
                ￥{{this.canApplyAmount | addThousandSign(2)}} <span style="color:red;font-size: smaller;">  （本次融资产品最高融资比例为{{this.canApplyRate}}%）</span>
              </el-form-item>  
              <el-form-item label="本次申请融资金额"
               prop="applyAmount">
               <el-input type="text " placeholder="请输入本次申请融资金额"
                          v-model="step5Form.applyAmount"></el-input>
              </el-form-item>               
              <el-form-item label="应收账款到期日"
               prop="accountsReceivableEndTime">
                <el-date-picker type="date" :disabled="!showAccountsReceivableEndTime"
                  ref="accountsReceivableEndTime"
                  @change="dateChange($event,'accountsReceivableEndTime')"
                  placeholder="应收账款到期日"
                  v-model="step5Form.accountsReceivableEndTime"
                  value-format="yyyy-MM-dd"></el-date-picker>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <div>
          <el-row :gutter="0">
            <el-col :span="24">
              <h1 class="step-form_main__title">应收账款</h1>
              <el-table :data="voucherInfoList"
                style="width: 100%;margin-top:20px;"
                :row-class-name="tableRowClassName">
                <el-table-column prop="buyerName"
                 label="买方"
                 align="center">
                </el-table-column>
                <el-table-column label="应收账款金额"
                 align="center">
                <template slot-scope="scope">￥{{scope.row.receivableAmount | addThousandSign(2)}}</template>
                </el-table-column>
                <el-table-column 
                 prop="authStateName"
                 label="审核状态"
                 align="center">
                </el-table-column>
                <el-table-column label="应收账款净额"
                 align="center">
                  <template slot-scope="scope">￥{{scope.row.netAmount | addThousandSign(2)}}</template>
                </el-table-column>
              </el-table>
              <div :class="this.$route.query.yanse == 1 ? 'step-from_main__money2' : 'step-from_main__money'" >
                <span>应收账款总金额：<i>￥{{this.receivableAmountSum | addThousandSign(2)}}</i></span>
                <span style="padding-left:30px;">应收账款总净额：<i>￥{{this.netAmountSum | addThousandSign(2)}}</i></span>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="step-form_main__name">
          <el-row :gutter="0">
            <el-col :span="24">
              <h1 class="step-form_main__title">经办人信息</h1>
              <div :class="this.$route.query.yanse == 1 ? 'deo-company-main-body2' : 'deo-company-main-body'">
                <ul class="deo-company-list-box">
                  <li>
                    <div class="deo-company-list-left">经办人</div>
                    <div class="deo-company-list-right">{{this.agent}}</div>
                  </li>
                  <li>
                    <div class="deo-company-list-left">经办人身份证</div>
                    <div class="deo-company-list-right">{{this.agentIdNo}}</div>
                  </li>
                  <li>
                    <div class="deo-company-list-left">经办人电话</div>
                    <div class="deo-company-list-right">{{this.agentContact}}</div>
                  </li>
                  <li>
                    <div class="deo-company-list-left">其他说明</div>
                    <div class="deo-company-list-right">{{this.remark}}</div>
                  </li>
                </ul>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="step-from_main__bank">
          <el-row :gutter="0">
            <el-col :span="24">
              <h1 class="step-form_main__title">银行账户信息</h1>
              <div  :class="this.$route.query.yanse == 1 ? 'deo-company-main-body2' : 'deo-company-main-body'" >
                <ul class="deo-company-list-box" v-for="item in bankAccounts">
                  <li>
                    <div class="deo-company-list-left">银行名称</div>
                    <div class="deo-company-list-right">{{item.bankName}}</div>
                  </li>
                  <li>
                    <div class="deo-company-list-left">账户类型</div>
                    <div class="deo-company-list-right">{{item.bankUseType | formatBankUseType}}</div>
                  </li>
                  <li>
                    <div class="deo-company-list-left">银行卡号</div>
                    <div class="deo-company-list-right">{{item.bankAccountName | replaceBankcardNumWithStar}}</div>
                  </li>
                </ul>
              </div>
              
            </el-col>
          </el-row>
        </div>
        <div class="step-from_main__enclosure">
          <el-row :gutter="0">
            <el-col :span="24">
              <h1 class="step-form_main__title">资料附件</h1>
              <div class="step-form_main__picture file-list__item-content" :key="index" v-if="item.idsarr.length != 0" v-for="(item, index) in fileTypeLists">
                <h5 :class="this.yanse == 1 ?'smalltitle2':'smalltitle'">{{item.name}}</h5>
                <ul class="file-list__item-list">
                <template v-for="file in item.idsarr">
                  <li
                    v-if="/\.pdf|\.doc|\.rar|\.zip|\.7z/g.test(file.fileName)" :class="['file-list__item-preview', `file-list__${file.fileName.substr(file.fileName.lastIndexOf('.')+1)}-preview`]"
                    @click.self="showPreviewImage(file.fileId, false)">
                    <div class="file-list__file-name">{{file.fileName}}</div>
                  </li>
                  <li v-else class="file-list__item-preview">
                    <img :src="`${ajaxBaseUrl}/mobile/crmCustomerAttachInfoController/getFile.ht?fileId=${file.fileId}&tokenId=${userInfo.token}`" @click="showPreviewImage(file.fileId, true)">
                  </li>                  
                </template>
                </ul>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="step-form__btn-container">
          <button v-if="this.$route.query.yanse == 1"
            class="step-form__btn-prev2"
            @click="goBack">上一步</button>
          <button v-if="this.$route.query.yanse == 1"
            class="step-form__btn-next2"
            @click="submitForm">提交</button>
          <button v-if="this.$route.query.yanse == 1"
            style="margin-right:10px;"
            class="step-form__btn-next2"
            @click="seeFinancing()">费用预估</button>            
          <button v-if="this.$route.query.yanse == 2"
            class="step-form__btn-prev"
            @click="goBack">上一步</button>
          <button v-if="this.$route.query.yanse == 2"
            class="step-form__btn-next"
            @click="submitForm">提交</button>
          <button v-if="this.$route.query.yanse == 2"
            class="step-form__btn-next"
            style="margin-right:10px;"
            @click="seeFinancing()">费用预估</button>            
        </div>
      </div>
    </div>
    <!-- 融资预览 -->
    <div class="repaymentFrom">
      <el-dialog @close="closeFrom()" title="费用预估" :append-to-body="true" :modal="false" :visible.sync="dialogFormVisible">
        <div class="repaymentFrom_label">
          <div class="flex_label">
            <div>融资申请金额(元)：</div>
            <el-input
              type="textarea"
              autosize
              :disabled="true"
              placeholder="请输入内容"
              v-model="step5Form.applyAmount">
            </el-input>
          </div>
          <div class="flex_label flex_label_02">
            <div>融资期限：</div>
            <el-input
              type="textarea"
              autosize
              :disabled="true"
              placeholder="请输入内容"
              value="今日">
            </el-input>
            <div style="margin:0 10px;">至</div>
            <el-date-picker type="date"
            :disabled="true"
              ref="accountsReceivableEndTime"
              @change="setFactime($event,'accountsReceivableEndTime')"
              placeholder="融资到期时间"
              v-model="financData.time"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </div>
        </div>
        <div class="repaymentFrom_label">
          <div class="flex_label">
            <div>保理年化费率(%)：</div>
            <el-input
              type="Number"
              autosize
              :maxlength="3"
              @change="feelvChange()"
              placeholder="请输入保理费率"
              v-model="financData.feelv">
            </el-input>
          </div>
          <div class="flex_label">
            <div>还款方式：</div>
            <el-input
              type="textarea"
              autosize
              :disabled="true"
              placeholder="请输入内容"
              v-model="financData.type">
            </el-input>
          </div>
        </div>
        <div class="repaymentFrom_label">
          <el-button type="primary" @click="testFlse()" round>预览还款计划</el-button>
        </div>
        <transition name="el-fade-in-linear">
          <div class="repaymentFrom_ul" v-show="testShow">
            <div class="repaymentFrom_li">
              <div class="repay-width repay-center repaymentFrom_num">期数</div>
              <div class="repay-width repay-center repaymentFrom_principal">本金</div>
              <div class="repay-width repay-center repaymentFrom_fee">保理费</div>
              <div class="repay-width repay-center repaymentFrom_day">计划还款日</div>
              <div class="repay-width repay-center repaymentFrom_amount">计划还款金额</div>
            </div>
            <!-- :key="index" v-for="(item, index) in gridData" -->
            <div class="repaymentFrom_li">
              <div class="repay-width repaymentFrom_num">{{financData.nper}}</div>
              <div class="repay-width repaymentFrom_principal">{{Number(step5Form.applyAmount).toFixed(2)}}</div>
              <div class="repay-width repaymentFrom_fee">{{(Number(step5Form.applyAmount)*(financData.days-1)*financData.feelv/36000).toFixed(2)}}</div>
              <div class="repay-width repaymentFrom_day">{{step5Form.accountsReceivableEndTime}}</div>
              <div class="repay-width repaymentFrom_amount">{{(Number(step5Form.applyAmount)+(Number(step5Form.applyAmount)*(financData.days-1)*financData.feelv/36000)).toFixed(2)}}</div>
            </div>
          </div>
        </transition>
      </el-dialog>
    </div>
    <!-- 提示 -->
    <el-dialog :visible.sync="dialogTicketInfo"
       :show-close="true"
       top="70px">
      <div v-html="contractText"></div>
    </el-dialog>
    <div class="mask" v-if="dialogFormVisible"></div>
  </section>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import * as types from "../../vuex/types";
import _ from "lodash";
import axios from "axios";
import applyloanApi from "../../api/applyloan"; // 引入企业证件API
import ElButton from "../../../node_modules/element-ui/packages/button/src/button";
import ElDialog from "../../../node_modules/element-ui/packages/dialog/src/component";
import loanApi from "../../api/myloan_bl";
// 企业那边如果界面差异变大，则建议分出去另一个组件
export default {
  components: {
    ElDialog,
    ElButton
  },
  directives: {
    focus: {
      inserted: function(el) {
        el.querySelector("input").focus();
      }
    }
  },
  filters: {
    formatBankUseType (data) {
      if (data == undefined) {
        return '--';
      }
      if(data.indexOf("0")!=-1 && data.indexOf("1")!=-1){
        return "回款专户、结算账户";
      }else if(data.indexOf("0")!=-1 && data.indexOf("1")==-1){
        return "回款专户";
      }else if(data.indexOf("0")==-1 && data.indexOf("1")!=-1){
        return "结算账户";
      }
    }
  },  
  data() {
    return {
      applyCode:'',
      showAccountsReceivableEndTime:false,
      applyAmount:'',//融资申请金额
      canApplyAmount:'',//可融资申请金额
      canApplyRate:'',//可融资比例
      testShow: false,
      // 预览还款计划
      dialogTableVisible: false,
      dialogFormVisible: false,
      financData: {
        numas: 0,
        feelv: "",
        type: "一次性到期还本付息",
        time: "",
        nper: 1,
        factoringfee: 0,
        desc: "",
        days:0//计息天数
      },
      formLabelWidth: "80px",
      voucherInfoList: [
        {
          buyerName: "",
          receivableAmount: "0",
          authStateName: "",
          netAmount: "0"
        }
      ],
      fileTypeLists: [],
      fileItemLists: [],
      netAmountSum: "0",
      receivableAmountSum: "0",
      yanse: "",
      fullscreenLoading: false,
      frontApplyId: 0,
      loanProductDetail: "",
      FrontApplyInfo: "",
      dialogTicketInfo: false,
      contractText: "",
      isSubmitting: false,
      isEditable: "",
      screenHeight: document.body.clientHeight,
      agent: "",
      agentContact: "",
      agentIdNo: "",
      remark: "",
      bankCardNo: "",
      bankName: "",
      step5Form: {
        accountsReceivableEndTime: "",
        applyAmount:""
      },
      bankAccounts:[],//银行账户信息
      rules: {
        accountsReceivableEndTime: [
          {
            trigger: "blur",
            required: true,
            validator: (rules, value, callback) => {
              if(this.$route.query.productName == "票据融资" || this.$route.query.yanse == 1){
                callback();
              }else{
                if (_.trim(value) === "") {
                  callback(new Error("请选择应收账款日期"));
                } else {
                  callback();
                }
              }
            }
          }
        ],
        applyAmount: [
          {
            trigger: "blur",
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === "") {
                callback(new Error("请输入本次融资申请金额"));
              } else if(Number(value)>Number(this.canApplyAmount).toFixed(2)){
                callback(new Error("融资申请金额不能大于最大可融资金额"));
              }else {
                callback();
              }
            }
          }
        ]
      }
    };
  },
  computed: {
    ...mapGetters({
      ajaxBaseUrl: types.GET_AJAX_BASE_URL,
      myInfo: types.GET_MY_INFO,
      userInfo: types.GET_USER
    })
  },
  methods: {
    inputBlurFn(prop) {
      if (event.srcElement) {
        this.step1Form[prop] = event.srcElement.value;
      }
    },
    ...mapActions({
      updatePassword: types.UPDATE_PASSWORD,
      getPersonalInfo: types.GET_PERSONAL_INFO,
      getEnterpriseInfo: types.GET_ENTERPRISE_INFO,
      savePersonalInfo: types.SAVE_PERSONAL_INFO,
      saveEnterpriseInfo: types.SAVE_ENTERPRISE_INFO,
      saveApplyLoanProgress: types.SAVE_APPLY_LOAN_PROGRESS,
      setSuccessMessage: types.SET_SUCCESS_MESSAGE,
      setFailMessage: types.SET_FAIL_MESSAGE
    }),
    seeFinancing() {
      this.$refs["step5Form"].validate((valid, object) => {
        if (valid) {
          this.dialogFormVisible = true;
          this.testShow = false;
          this.financData.days = this.getDaysBetween(this.step5Form.accountsReceivableEndTime);
        } else {
          let dom = this.$refs["step5Form"];
          dom.$el.scrollIntoView({
            //滚动到指定节点
            block: "center", //值有start,center,end，nearest，当前显示在视图区域中间
            behavior: "smooth" //值有auto、instant,smooth，缓动动画（当前是慢速的）
          });
        }
      });      
    },
    closeFrom() {
      this.testShow = false;
    },
    testFlse() {
      // financData.feelv?testShow = !testShow: false
      if (!this.financData.feelv) {
        this.$message({
          showClose: true,
          message: "请输入保理费率",
          type: "warning"
        });
        return false;
      } else if (!this.financData.time) {
        this.$message({
          showClose: true,
          message: "请输入融资期限",
          type: "warning"
        });
        return false;
      } else {
        this.testShow = true;
      }
    },
    feelvChange() {
      if (!this.financData.feelv) {
        this.testShow = false;
      }
    },
    setFactime(e, type) {
      if (e) {
        const date = e
          .replace(/(\s*)/g, "")
          .replace(/年/, "-")
          .replace(/月/, "-")
          .replace(/日/, "");
        this.financData.time = date;
      }
    },
    dateChange(e, type) {
      if (e) {
        const date = e
          .replace(/(\s*)/g, "")
          .replace(/年/, "-")
          .replace(/月/, "-")
          .replace(/日/, "");
        this.financData.time = date;
        this.step5Form.accountsReceivableEndTime = date;
      }
    },
    goBack() {
      this.$router.push({
          name: "step4_bl",
          params: this.$route.params,
          query: this.$route.query
      });
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 1) {
        return "warning-row";
      } else if (rowIndex === 3) {
        return "success-row";
      }
      return "";
    },
    getInfo() {
      loanApi
        .getItemDetails({
          // 详情
          tokenId: localStorage.getItem("dl_tokenId_bl"),
          frontApplyId: this.$route.query.frontApplyId
        })
        .then(res => {
          if (res.rspcode == 1) {
            this.agent = res.data.frontApply.agent;
            this.agentContact = res.data.frontApply.agentContact;
            this.agentIdNo = res.data.frontApply.agentIdNo;
            this.remark = res.data.frontApply.remark;
            var bankNameStr = res.data.frontApply.bankNameName;
            this.bankAccounts = res.data.bankAccounts;
            this.applyCode = res.data.frontApply.applyCode;
          } else {
            this.setFailMessage({
              show: true,
              content: res.rspdesc || "数据获取失败"
            });
          }
        })
        .catch(error => {});
    },
    getFrontVoucherInfoList() {
      if(this.$route.query.productName == "票据融资" || this.$route.query.yanse == 1){
        this.showAccountsReceivableEndTime = false;
      }else{
        this.showAccountsReceivableEndTime = true;
      }
      // 凭证列表
      loanApi
        .getFrontVoucherInfoList({
          tokenId: localStorage.getItem("dl_tokenId_bl"),
          frontApplyId: this.$route.query.frontApplyId,
          pageNum:1,
          pageSize:999,
          type: "get"
        })
        .then(res => {
          if (res.rspcode == 1) {
            this.voucherInfoList = res.data.voucherInfoList;
            this.netAmountSum = res.data.netAmountSum;
            this.receivableAmountSum = res.data.receivableAmountSum;
            this.canApplyAmount = res.data.canApplyAmount;
            if(Number(this.canApplyAmount)>0){
              this.step5Form.applyAmount = this.canApplyAmount.toFixed(2);
            }
            this.canApplyRate = res.data.canApplyRate;
            if(this.$route.query.productName == "票据融资" || this.$route.query.yanse == 1){
              this.step5Form.accountsReceivableEndTime = res.data.accountsReceivableEndTime;
            }
          }
        })
        .catch(error => {});
    },
    //      附件列表接口
    goItemFilesPage() {
      const param = {
        tokenId: localStorage.getItem("dl_tokenId_bl"),
        frontApplyId: this.$route.query.frontApplyId
      };
      applyloanApi
        .goItemFilesPage(param)
        .then(res => {
          if (res.rspcode === 1) {
            this.fileTypeLists = res.data.itemFiles;
            this.fileItemLists = res.data.itemFiles;
          } else {
            this.setFailMessage({
              show: true,
              content: res.rspdesc || "数据获取失败"
            });
          }
        })
        .catch(error => {
          this.setFailMessage({
            show: true,
            content: "网络异常，请稍后再试"
          });
        });
    },
    showPreviewImage(fileId, isImage) {
      const src = `${
        this.ajaxBaseUrl
      }/mobile/crmCustomerAttachInfoController/getFile.ht?fileId=${fileId}&tokenId=${
        this.userInfo.token
      }`;
      if (isImage) {
        this.filePreview = {
          show: true,
          src
        };
      } else {
        window.open(`${location.origin}${src}`);
      }
    },
    //获取两日间相隔天数
    getDaysBetween(dateString){
      var endDate = Date.parse(dateString);
      var days=(endDate - new Date())/(1*24*60*60*1000);
      return parseInt(days)+2;
    },    
    submitForm() {
      this.$refs["step5Form"].validate((valid, object) => {
        if (valid) {
          const param = {
            tokenId: localStorage.getItem("dl_tokenId_bl"),
            frontApplyId: this.$route.query.frontApplyId,
            accountsReceivableEndTime: this.step5Form.accountsReceivableEndTime,
            applyAmount:this.step5Form.applyAmount//融资申请金额
          };
          this.$confirm("是否提交申请 ?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            applyloanApi
              .confirmApply(param)
              .then(res => {
                this.fullscreenLoading = false; // loading遮罩层
                if (res.code === 1) {
                  if(this.$route.query.yanse == 1){
                    this.setSuccessMessage({
                      show: true,
                      content: "提交成功，请前往签署融资申请书"
                    });
                    //跳转合同列表
                    setTimeout(() => {
                      this.$router.push({path: '/personalCenter/projectContract/list', query: { frontApplyId: this.$route.query.frontApplyId }});
                    }, 2000);                    
                  }else{
                    this.setSuccessMessage({
                      show: true,
                      content: res.result || "提交成功"
                    });
                    //跳转我的保理
                    setTimeout(() => {
                      this.$router.push({
                        path: "/personalCenter/myLoan_bl",
                        query: {}
                      });
                    }, 2000);
                  }
                } else {
                  this.setFailMessage({
                    show: true,
                    content: res.result || "数据获取失败"
                  });
                }
              })
              .catch(error => {
                this.fullscreenLoading = false; // loading遮罩层
                this.setFailMessage({
                  show: true,
                  content: "网络异常，请稍后再试"
                });
              });
          });
        } else {
          let dom = this.$refs["step5Form"];
          dom.$el.scrollIntoView({
            //滚动到指定节点
            block: "center", //值有start,center,end，nearest，当前显示在视图区域中间
            behavior: "smooth" //值有auto、instant,smooth，缓动动画（当前是慢速的）
          });
        }
      });
    }
  },
  created() {
    this.yanse = this.$route.query.yanse;
  },
  mounted() {
    this.$store.commit('changeActive', 5);
    this.getInfo();
    this.getFrontVoucherInfoList();
    this.goItemFilesPage();
  }
};
</script>
<style lang="scss">
.step-form__step-num2 {
  box-shadow: 0 0 46px rgba(253, 180, 69, 0.3);
  position: absolute;
  left: 33px;
  border-radius: 50%;
  width: 52px;
  height: 52px;
  line-height: 52px;
  color: #36a444;
  font-family: "Microsoft YaHei";
  font-weight: 700;
  font-size: 24px;
  text-align: center;
  background-color: #fff;
}
.step-form__step-num {
  box-shadow: 0 0 46px rgba(253, 180, 69, 0.3);
  position: absolute;
  left: 33px;
  border-radius: 50%;
  width: 52px;
  height: 52px;
  line-height: 52px;
  color: #eb662b;
  font-family: "Microsoft YaHei";
  font-weight: 700;
  font-size: 24px;
  text-align: center;
  background-color: #fff;
}
.el-input.is-disabled .el-input__inner {
  background: #f7f7f7;
}

.step1-form .step-form__title {
  padding-bottom: 60px;
}
.step-form__form .el-form-item {
  margin-bottom: 5px !important;
}
.step-form__form .el-form-item__label {
  line-height: 40px;
}
.protocol_cont {
  margin-top: 35px;

  .el-form-item__error {
    margin-top: -12px;
  }
}
.step1__show-loan-contract {
  color: #eb662b;
}
.color2 {
  color: #36a444;
}

.step-form__btn-prev {
  background: #ff9f75;
  float: left;
  @include step-form__btn;
}
.step-form__btn-next {
  background: #eb662b;
  float: right;
  @include step-form__btn;
}
.step-form__btn-prev2 {
  background: #75bc42;
  float: left;
  @include step-form__btn;
}
.step-form__btn-next2 {
  background: #36a444;
  float: right;
  @include step-form__btn;
}
.step-form__btn-container {
  @include clear;
}
.step-form_main__name {
  height: 205px;
  padding-top: 50px;
}
.deo-company-main-body {
  .deo-company-list-box {
    float: left;
    margin-top: 20px;
    width: 100%;
    box-sizing: border-box;

    li {
      font-size: 14px;
      color: #333;
      .deo-company-list-left {
        border-left: 1px solid #ffeee3;
        border-top: 1px solid #ffeee3;
        border-bottom: 1px solid #ffeee3;
        background: #fffaf4;
        width: 174px;
        text-align: center;
        float: left;
        line-height: 40px;
        box-sizing: border-box;
      }
      .deo-company-list-right {
        height: 40px;
        border: 1px solid #f2f2f3;
        width: 78%;
        float: right;
        padding-left: 10px;
        line-height: 40px;
      }
    }
  }
}
.deo-company-main-body2 {
  // height: 245px;
  // padding-top: 25px;
  .deo-company-list-box {
    float: left;
    margin-top: 20px;
    width: 100%;
    box-sizing: border-box;

    li {
      font-size: 14px;
      color: #333;
      .deo-company-list-left {
        border-left: 1px solid #b3ef88;
        border-top: 1px solid #b3ef88;
        border-bottom: 1px solid #b3ef88;
        background: #c4f7cf;
        width: 174px;
        text-align: center;
        float: left;
        line-height: 40px;
        box-sizing: border-box;
      }
      .deo-company-list-right {
        height: 40px;
        border: 1px solid #f2f2f3;
        width: 78%;
        float: right;
        padding-left: 10px;
        line-height: 40px;
      }
    }
  }
}
.step-form_main__title {
  font-size: 20px;
}
.step-from_main__money {
  margin-top: 15px;
  font-size: 15px;
  color: #999;
  span {
    display: inline-block;
    i {
      color: #eb662b;
      font-style: normal;
      font-size: 16px;
    }
  }
}
.step-from_main__money2 {
  margin-top: 15px;
  font-size: 15px;
  color: #999;
  span {
    display: inline-block;
    i {
      color: #36a444;
      font-style: normal;
      font-size: 16px;
    }
  }
}
.step-from_main__bank {
  padding-top: 50px;
}
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
.step-from_main__enclosure {
  margin-top: 50px;
  .step-form_main__picture {
    padding-top: 30px;
    padding-bottom: 30px;
    .smalltitle {
      font-family: "FZLanTingHei-DB-GBK";
      font-size: 18px;
      color: #ff8b38;
      text-align: center;
      padding-bottom: 30px;
    }
    .smalltitle2 {
      font-family: "FZLanTingHei-DB-GBK";
      font-size: 18px;
      color: #36a444;
      text-align: center;
      padding-bottom: 30px;
    }
    img {
      width: 365px;
      height: 233px;
      padding-left: 30px;
      padding-top: 20px;
    }
  }
}
.repaymentFrom {
  position: relative;
  display: flex;
  .el-dialog__wrapper {
    z-index: 2001 !important;
  }
  .el-dialog--small {
    width: 900px;
    display: flex;
    flex-direction: column;
    .repaymentFrom_label {
      display: flex;
      margin-bottom: 15px;
      align-items: center;
      .flex_label {
        flex: 1;
        display: flex;
        align-items: center;
        .el-input {
          width: 70%;
        }
        .el-textarea {
          width: 70%;
        }
        .el-date-editor {
          width: 70%;
        }
      }
      .flex_label_02{
        .el-textarea {
          width: 20%;
          text-align: center;
          .el-textarea__inner{
            text-align: center;
          }
        }
        .el-input {
          width: 41%;
        }
      }
    }
    .repaymentFrom_ul {
      position: relative;
      display: flex;
      width: 100%;
      border: 1px solid #ccc;
      flex-direction: column;
      .repaymentFrom_li {
        display: flex;
        width: 100%;
        .repay-width {
          flex: 1;
          text-align: center;
          border: 1px solid #ccc;
          font-size: 15px;
          padding: 5px 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: rgb(139, 134, 134);
        }
        .repay-center {
          text-align: center;
        }
        .repaymentFrom_num {
        }
      }
    }
  }
}
.mask {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  background: #000;
  z-index: 1000;
}
</style>



// WEBPACK FOOTER //
// Step5.vue?94b83e8e